export enum ClassStatus {
    IsActive = 1,
    NotActive =0
   
}